import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SignInfo } from 'domain-models/SignInfo';
import { Helper } from 'libraries/Helper';
import { Page } from 'libraries/Page';

@Component({
	selector: 'weight-station-sign',
	templateUrl: './weight-station-sign.component.html',
	styleUrls: ['./weight-station-sign.component.css']
})
export class WeightStationSignComponent implements OnInit {
	@Input('message') message: string = '';
	@Input('sign') sign: SignInfo;
	@Input('groupName') groupName: string;
	@Input('controlComponent') controlComponent: boolean = false;
	@Input('selected') selected;
	@Output() signClicked = new EventEmitter<{
		id: number;
		isSelected: boolean;
	}>();
	parsedMultistring: Array<Page>;
	currentPageMessage: string;
	loading: boolean = false;
	private currentPage: number;
	compressedFont: boolean = false;
	signWidth: any;
	constructor() {
		// this.sign = new SignInfo();
	}

	ngOnInit() {
		if (this.sign) {
			this.message = this.sign.CurrentMessage;
		}
	}
	canBeControlled() {
		// Don't allow click or any feedback on control page
		if (this.controlComponent) {
			return;
		}

		// if (this.sign && this.sign.Status == 'Offline') {
		// 	Helper.alert('This sign is <b>' + this.sign.Status + '</b> so it can <b>NOT</b> be selected');
		// }
		if (this.sign && this.sign.SignCanControl) {
			this.signClicked.emit({ id: this.sign.Id, isSelected: !this.selected });
		} else {
			Helper.alert('You can NOT control this sign.');
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/display/weight-station-sign/weight-station-sign.component.ts